import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Info } from "@mui/icons-material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 400,
  width: "100%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function ModalAppropriation(data) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  console.log(data.data, "modal");

  return (
    <div>
      <Button onClick={handleOpen}><Info /></Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Typography id="transition-modal-title" variant="h4" component="h2" sx={{ mb: 2 }}>
              Ball
            </Typography>
            <Typography id="transition-modal-description" variant="h6" sx={{ mb: 2 }}>
              {
                data.data.avg_point
              }
            </Typography>
            <Typography id="transition-modal-title" variant="h4" component="h2" sx={{ mb: 2 }}>
              O`rin
            </Typography>
            <Typography id="transition-modal-description" variant="h6" sx={{ mb: 2 }}>
              {
                data.data.rating + " / " + data.data.student_count
              }
            </Typography>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
